import {getElements} from "./utils/getElement";
import Flickity from "flickity";

const initProductCarousel = () => {
  const productCarousels = getElements('.js-carousel-mobile')

  if (!productCarousels) {
    return;
  }

  productCarousels.map(carousel => {

    let flickityInstance;

    const initCarousel = () => {
      if (window.matchMedia('(max-width: 767px)').matches) {
        flickityInstance = new Flickity(carousel, {
          cellAlign: 'center',
          setGallerySize: false,
          contain: true,
          imagesLoaded: true,
          prevNextButtons: false,  // we'll handle prev/next ourselves
          pageDots: false,
          wrapAround: true,
          groupCells: false
        });

        return flickityInstance;
      }
    }

    const resizeWatcher = (flickityInst) => {
      window.addEventListener('resize', () => {
        if (window.matchMedia('(max-width: 767px)').matches) {
          const carouselInst = initCarousel()
        } else {
          flickityInstance.destroy()
        }
      });
    }

    initCarousel()
    resizeWatcher(flickityInstance)

    let btnPrev;
    let btnNext;
    if (carousel.parentNode.classList.contains('c-showcase__main')) {
      btnPrev = carousel.parentNode.parentNode.querySelector('.js-offers-carousel-prev');
      btnNext = carousel.parentNode.parentNode.querySelector('.js-offers-carousel-next');
    } else {
      btnPrev = carousel.parentNode.querySelector('.js-offers-carousel-prev');
      btnNext = carousel.parentNode.querySelector('.js-offers-carousel-next');
    }


    if (btnPrev) {
      btnPrev.addEventListener('click', () => {
        // Move to previous slide
        flickityInstance.previous();
      });
    }

    if (btnNext) {
      btnNext.addEventListener('click', () => {
        // Move to next slide
        flickityInstance.next();
      });
    }
  })
}

export {initProductCarousel}